import { render, staticRenderFns } from "./ChatbotAvatar.vue?vue&type=template&id=6b966e8c&scoped=true&lang=pug&"
import script from "./ChatbotAvatar.vue?vue&type=script&lang=ts&"
export * from "./ChatbotAvatar.vue?vue&type=script&lang=ts&"
import style0 from "./ChatbotAvatar.vue?vue&type=style&index=0&id=6b966e8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b966e8c",
  null
  
)

export default component.exports